import { Page } from '../../types'

const detectedBribery: Page[] = [
    {
        pageType: 'question',
        title: 'Detected bribery',
        name: 'detected-bribery',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'detected-bribery-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'detected-bribery-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'detected-bribery-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default detectedBribery
